import { useState } from 'react'
import { t } from 'i18next'
import { IFormModel } from 'types'

/**
 * Form constants
 */
const SEARCH = 'search'
const GROUP = 'group'
const COURSE = 'course'
const STATUS = 'status'

/**
 * Form model
 */
const formModel = (): IFormModel  => {
  return {
    [SEARCH]: {
      label: `${t('common.search-table')}`,
      name: SEARCH,
    },   
    [GROUP]: {
      label: `${t('common.group')}`,
      name: GROUP,
    },
    [COURSE]: {
      label: `${t('common.course')}`,
      name: COURSE,
    },
    [STATUS]: {
      label: `${t('common.status')}`,
      name: STATUS,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [SEARCH]: '',
  [GROUP]: null, // single select
  [COURSE]: null, // single select
  [STATUS]: null, // single select
}

/**
 * Form state
 */
export const useParams = () => {
  const [params, setParams] = useState(initialValues)

  return { params, setParams }
}

export default formModel
